import { useNavigate, useLocation } from 'react-router-dom';
import { House, PlusCircle, User, ListChecks } from '@phosphor-icons/react';

import { useAuthStore } from '@/stores';
import { ROUTES } from '@/constants';

import styles from './BottomNav.module.css';

export function BottomNav() {
    const navigate = useNavigate();
    const location = useLocation();
    const { isLogged, getUser } = useAuthStore();
    const user = getUser();

    const navItems = [
        { icon: <House size={24} weight={location.pathname === ROUTES.feed ? 'fill' : 'regular'} />, label: 'Inicio', path: ROUTES.feed, isCreate: false },
        ...(isLogged
            ? [
                { icon: <PlusCircle size={24} weight={location.pathname === ROUTES.create ? 'fill' : 'regular'} />, label: 'Crear', path: ROUTES.create, isCreate: true },
                { icon: <ListChecks size={24} weight={location.pathname === ROUTES.myPolls ? 'fill' : 'regular'} />, label: 'Mis enc.', path: ROUTES.myPolls, isCreate: false },
                { icon: <User size={24} weight={user && location.pathname === `/${user.slug}` ? 'fill' : 'regular'} />, label: 'Perfil', path: user ? `/${user.slug}` : ROUTES.login, isCreate: false },
            ]
            : [
                { icon: <User size={24} />, label: 'Iniciar', path: ROUTES.login, isCreate: false },
            ]),
    ];

    return (
        <nav className={styles.nav}>
            {navItems.map((item) => {
                const isActive = location.pathname === item.path;

                return (
                    <button
                        key={item.path}
                        className={`${styles.item} ${isActive ? styles.active : ''} ${item.isCreate ? styles.createItem : ''}`}
                        onClick={() => navigate(item.path)}
                        aria-label={item.label}
                    >
                        {item.icon}
                        <span className={styles.label}>{item.label}</span>
                    </button>
                );
            })}
        </nav>
    );
}
